import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import configs from '../../../../config/config';
import '../../../../assets/stylesheets/Dialogs/Join.scss'
import { requestJoinClub } from "../../../../store/actionCreators/club";

const Join = ({ }) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({});

    const handleInputChange = event => {
        event.persist();
        setFormState(formState => ({
            ...formState,
            [event.target.name]: event.target.value,
        }
        ))
    };
    const joinClub = () => {
        if (formState.clubId) {
            // dispatch(openDialog('clubConfirmation', { clubDetails: formState }));
            dispatch(requestJoinClub(formState));
        }
    };

    return (
        <div className={`fieldSet`}>
            <Form.Group className={`field`}>
                <Form.Label className={`label`}>
                    {t('clubId')}
                </Form.Label>
                <Form.Control
                    type="number"
                    name="clubId"
                    defaultValue={formState.clubId}
                    onChange={handleInputChange}
                />
            </Form.Group>
            {configs.userExtraRoles.includes('agent') && <Form.Group className={`field`}>
                    <Form.Label className={`label`}>
                        {t('agentId')}
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="agentId"
                        placeholder={'(optional)'}
                        defaultValue={formState.agentId}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            }
            <div className="dialogConfirmBox" onClick={joinClub}>
                <button className="primary">{t('join')}</button>
            </div>
        </div>
    );
};

export default Join;
